import INTERNAL_QUERY_PARAMS from "@/constants/internalQueryParams";

const embedMixins = {
  props: {
    id: {
      type: String,
      required: true,
    },
    preview: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sandboxPermissions:
        "allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation allow-storage-access-by-user-activation allow-downloads",
    };
  },
  computed: {
    surveyUrl() {
      return this.preview
        ? `${this.url}?${INTERNAL_QUERY_PARAMS.preview}=true`
        : this.url + this.queryParams;
    },
    queryParams() {
      const query = new URLSearchParams(window.location.search);
      return `?${query.toString()}`;
    },
  },
};

export default embedMixins;
